import Icon from '../Icon.vue'

Icon.register({
  'alert_fire': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M20 9.768C20 4.382 15.514 0 10 0 4.487 0 0 4.382 0 9.768c0 4.059 2.55 7.546 6.166 9.018-.602-.62-1.057-1.542-1.057-2.948 0-2.018.81-3.424 1.525-4.664.622-1.08 1.211-2.101 1.211-3.41 0-.794-.847-1.711-1.173-1.997a.436.436 0 01.044-.693.452.452 0 01.254-.079h.035c1.103 0 3.3.582 3.972 2.808.194.636.176 1.48.158 2.294-.02.845-.043 1.898.256 2.196.04.04.097.08.23.08.087 0 .297-.182.495-.667.458-1.127.425-2.672.065-3.002a.437.437 0 01.165-.741.46.46 0 01.303.003c.12.044 2.937 1.107 2.74 5.59-.117 2.67-1.121 4.513-2.41 5.537C17.041 17.853 20 14.14 20 9.768z'
      }
    ]
  }
})
